import { get } from '@alltrails/core/utils/get';

type GetNlSuggestionsParams = {
  center?: { lat: number; lng: number };
};

export async function getNlSuggestions({ center }: GetNlSuggestionsParams = {}) {
  const params: Record<string, string | number> = { limit: 6 };
  if (center) {
    params['location[center][lat]'] = center.lat;
    params['location[center][lng]'] = center.lng;
  }
  return get<any>(`/api/alltrails/explore/v1/query_suggestions`, { params });
}
